import React, { useContext, useEffect, useState } from "react";
import styled, { css } from "styled-components";
// import { storeProducts } from '../data';
import { ProductContext } from "../../context";
import Bg from "../Bg";
import ListRegular from "./ListRegular";
import Menu from "./Menu.js";
import Product from "./Product";
import PsLoader from "./PsLoader";
import Slider from "./Slider";

function ProductList({
  blockOrder = 0,
  title = true,
  filter,
  cardType,
  order, //TODO: сортировку для корзины и не только
  active = "virtualItems",
}) {
  //  console.log('cardType = ', cardType);

  const [activeModule, setActiveModule] = useState(active);

  // const changeGroupHandler = (newActive) => {
  //   valueFromContext.setStateFrom(
  //     'activeGroup', newActive
  //   )
  // }

  // const changeGlobalHandler = (newActive) => {
  //   valueFromContext.setStateFrom(
  //     'activeModule', newActive
  //   )
  // }

  const valueFromContext = useContext(ProductContext);

  let count = 1;

  useEffect(() => {
    if (
      !valueFromContext.virtualItems &&
      !valueFromContext.fetching &&
      valueFromContext["projectId"]
    ) {
      valueFromContext.setStateFrom("fetching", true);
      if (valueFromContext.psToken) {
        PsLoader(
          valueFromContext.psToken,
          "all",
          valueFromContext["projectId"]
        ).then((allData) => {
          valueFromContext.setCurrs(allData);
        });
      }
    } else {
      // debugger
    }
  }, []);

  useEffect(() => {
    if (
      valueFromContext["sections"][blockOrder]["activeModule"] !== activeModule
    ) {
      setActiveModule(valueFromContext["sections"][blockOrder]["activeModule"]);
    }
  }, [valueFromContext]);

  const makeList = (items) => {
    if (items) {
      let arr = [];

      items = items.filter((oneGroup, ind) => (valueFromContext["sections"][blockOrder]["activeGroup"] ===
          "first" && ind === 0) ||
        valueFromContext["sections"][blockOrder]["activeGroup"] === "all" ||
        valueFromContext["sections"][blockOrder]["activeGroup"] ===
          oneGroup["id"] ||
        valueFromContext["sections"][blockOrder]["activeGroup"] ===
          oneGroup["name"]
       )


      items.forEach((oneGroup, ind) => {
        let subArr = [];

        let sub = valueFromContext["sections"][blockOrder]["activeSubGroup"];
        if (sub && oneGroup.children.length) {
          let subGroup = oneGroup.children.filter(oneG=>oneG['id'] === sub)[0]
          oneGroup = subGroup ? subGroup : oneGroup
          debugger
        }
        console.log('oneGroup = ', oneGroup.products);

        if (!oneGroup.products.length && oneGroup.children.length) {
          oneGroup = oneGroup.children[0]
        }

        // if (
        //   (valueFromContext["sections"][blockOrder]["activeGroup"] ===
        //     "first" && ind === 0) ||
        //   valueFromContext["sections"][blockOrder]["activeGroup"] === "all" ||
        //   valueFromContext["sections"][blockOrder]["activeGroup"] ===
        //     oneGroup["id"] ||
        //   valueFromContext["sections"][blockOrder]["activeGroup"] ===
        //     oneGroup["name"]
        // ) {
          oneGroup.products.forEach((oneProduct, key) => {
            if (
              (!filter ||
                (filter === "is_favorite" && oneProduct["is_favorite"]) ||
                (filter === "in_cart" && oneProduct["in_cart"])) &&
              (!valueFromContext["sections"][blockOrder]["limit"] ||
                (valueFromContext["sections"][blockOrder]["limit"] &&
                  count <= valueFromContext["sections"][blockOrder]["limit"]))
            ) {
              count = count + 1;
              debugger
              let prod = {
                key: oneProduct.id,
                template: valueFromContext["sections"][blockOrder]["template"],
                id: oneProduct.id,
                order: count,
                initClass: "initialFlow1",
                sku: oneProduct.sku,
                name: oneProduct.name,
                cardType: "virtualItems",
                cardWidth: valueFromContext["sections"][blockOrder]["cardWidth"],
                theme: valueFromContext["sections"][blockOrder]["theme"] || valueFromContext.theme,
                description: oneProduct.description,
                price: oneProduct.amount,
                priceFull:
                  oneProduct.amount_without_discount || oneProduct.amount,
                discountPercent: oneProduct.discount_percent,
                image_url: oneProduct.image_url,
                currency: oneProduct.currency,
                product: oneProduct,
                addToCart: valueFromContext.addToCart,
                is_favorite: oneProduct.is_favorite || 0,
                in_cart: oneProduct.in_cart || 0,
              };
              arr = [...arr, prod];
              // subArr.push(prod)
            }
          });

          // arr = [...arr, ...subArr];
        // }
      });
      return arr;
    }
  };

  if (valueFromContext && valueFromContext.psToken) {
    return (
      <div style={{ position: "relative" }}>
        {valueFromContext &&
          valueFromContext["sections"][blockOrder]["theme"] &&
          cardType !== "cart" && (
            <CssListBg>
              <Bg
                absolute={true}
                image={false}
                theme={
                  valueFromContext["sections"][blockOrder]["theme"] ||
                  valueFromContext.theme
                }
              />
            </CssListBg>
          )}

        {cardType !== "cart" &&
          valueFromContext["sections"][blockOrder]["menu"] && (
            <CssStore00
              theme={
                valueFromContext["sections"][blockOrder]["theme"] ||
                valueFromContext.theme
              }
              cardType={activeModule}
              style={{
                // backgroundColor: valueFromContext['sections'][blockOrder]["theme"] || valueFromContext.theme['colorBg'],
                backgroundColor: "transparent",
                // color: valueFromContext['sections'][blockOrder]["theme"]['colorText'] || valueFromContext.theme['colorText'],
              }}
            >
              <Menu
                theme={valueFromContext["sections"][blockOrder]["theme"]}
                blockOrder={blockOrder}
              />
            </CssStore00>
          )}

        {(activeModule === "virtualItems" || filter === "in_cart") &&
          valueFromContext.virtualItems && (
            <CssProductList>
              {/* <CssList0> */}

              {activeModule === "virtualItems" &&
                valueFromContext["sections"][blockOrder]["slider"] &&
                valueFromContext.virtualItems && (
                  <Slider
                    theme={
                      valueFromContext["sections"][blockOrder]["theme"] ||
                      valueFromContext.theme
                    }
                    template={
                      valueFromContext["sections"][blockOrder]["template"]
                    }
                    cardWidth={
                      valueFromContext["sections"][blockOrder]["cardWidth"]
                    }
                    key={`slider_${blockOrder}`}
                    id={`slider_${blockOrder}`}
                    products={makeList(valueFromContext.virtualItems)}
                  />
                )}

              {activeModule === "virtualItems" &&
                !valueFromContext["sections"][blockOrder]["slider"] &&
                valueFromContext.virtualItems && (
                  <CssStore00
                    theme={
                      valueFromContext["sections"][blockOrder]["theme"] ||
                      valueFromContext.theme
                    }
                    cardType={activeModule}
                    style={{
                      // backgroundColor: valueFromContext['sections'][blockOrder]["theme"] || valueFromContext.theme['colorBg'],
                      backgroundColor: "transparent",
                      // color: valueFromContext['sections'][blockOrder]["theme"]['colorText'] || valueFromContext.theme['colorText'],
                    }}
                  >
                    <ListRegular
                      template={
                        valueFromContext["sections"][blockOrder]["template"]
                      }
                      theme={
                        valueFromContext["sections"][blockOrder]["theme"] ||
                        valueFromContext.theme
                      }
                      cardWidth={
                        valueFromContext["sections"][blockOrder]["cardWidth"]
                      }
                      key={`slider_${blockOrder}`}
                      id={`slider_${blockOrder}`}
                      products={makeList(valueFromContext.virtualItems)}
                    />


                  </CssStore00>
                )}

              {/* {(activeModule === 'virtualItems')
            && valueFromContext.virtualItems.map((oneGroup, ind) => {
            if (
              (

              valueFromContext['sections'][blockOrder]['activeGroup'] === 'first' && ind === 0 ||
              valueFromContext['sections'][blockOrder]['activeGroup'] === 'all' ||
              valueFromContext['sections'][blockOrder]['activeGroup'] === oneGroup['id'] ||
              valueFromContext['sections'][blockOrder]['activeGroup'] === oneGroup['name']) || filter === "in_cart"
            ) {
              return (
                <div key={`group_${ind}`}>



                    {cardType !== 'cart' &&
                    title && <СssTitle theme={valueFromContext['sections'][blockOrder]["theme"] || valueFromContext.theme}>
                      {typeof title === 'string' ? title : oneGroup.name}
                    </СssTitle>}


                    {activeModule === 'virtualItems' &&
                    valueFromContext['sections'][blockOrder]['slider'] &&
                    valueFromContext.virtualItems &&
                    <div style={{position: 'relative', zIndex: 10000}}>

                        <Slider key={`slider_${blockOrder}`} id={`slider_${blockOrder}`} products = {makeList(valueFromContext.virtualItems)} />

                    </div>}



                    <СssGroup
                      theme={valueFromContext['sections'][blockOrder]["theme"] || valueFromContext.theme}
                      cardWidth={valueFromContext['sections'][blockOrder]['cardWidth']}
                      cardType={cardType}
                    >
                      {oneGroup.products.length && oneGroup.products.map((oneProduct, key) => {
                        if ((!filter
                          || (filter === 'is_favorite' && oneProduct['is_favorite'])
                          || (filter === 'in_cart' && oneProduct['in_cart']))
                          &&  (
                            !valueFromContext['sections'][blockOrder]['limit'] ||
                            valueFromContext['sections'][blockOrder]['limit'] && count <= valueFromContext['sections'][blockOrder]['limit'])
                          ) {
                          count = count + 1;
                          return (
                          <Product
                            // ref={ProductRef}
                            key={oneProduct.id}
                            template={valueFromContext['sections'][blockOrder]['template']}
                            id={oneProduct.id}
                            order={count}
                            initClass="initialFlow1"
                            sku={oneProduct.sku}
                            title={oneProduct.name}
                            cardType="virtualItems"
                            cardWidth={valueFromContext['sections'][blockOrder]['cardWidth']}
                            theme={valueFromContext['sections'][blockOrder]["theme"] || valueFromContext.theme}
                            description={oneProduct.description}
                            price={oneProduct.amount}
                            priceFull={oneProduct.amount_without_discount || oneProduct.amount}
                            discountPercent={oneProduct.discount_percent}
                            image_url={oneProduct.image_url}
                            currency={oneProduct.currency}
                            product={oneProduct}
                            addToCart={valueFromContext.addToCart}
                            is_favorite = {oneProduct.is_favorite || 0}
                            in_cart = {oneProduct.in_cart || 0}
                          />
                        )} else {
                          return null
                        }
                      })

                    }
                  </СssGroup>
                </div>
              )


            }
          })} */}
            </CssProductList>
          )}

        {activeModule === "subscriptions" &&
          cardType !== "cart" &&
          !filter &&
          valueFromContext.subscriptions && (
            <CssProductList>
              {/* <CssList0> */}
              {title && (
                <СssTitle
                  theme={
                    valueFromContext["sections"][blockOrder]["theme"] ||
                    valueFromContext.theme
                  }
                >
                  Subscriptions
                </СssTitle>
              )}
              {/* </CssList0> */}
              <СssGroup
                quantity={valueFromContext.subscriptions["packages"]}
                cardWidth={
                  valueFromContext["sections"][blockOrder]["cardWidth"]
                }
                theme={
                  valueFromContext["sections"][blockOrder]["theme"] ||
                  valueFromContext.theme
                }
                cardType="subscriptions"
              >
                {valueFromContext.subscriptions["packages"].map(
                  (oneSubscr, key) => {
                    count = count + 1;
                    return (
                      <div key={"key" + oneSubscr["id"]}>
                        <Product
                          // ref={ProductRef}
                          key={key}
                          order={key}
                          template={
                            valueFromContext["sections"][blockOrder]["template"]
                          }
                          initClass="initialFlow1"
                          sku={key}
                          title={oneSubscr.name}
                          description={oneSubscr.description}
                          price={oneSubscr.charge_amount}
                          priceFull={oneSubscr.charge_amount_without_discount}
                          currency={oneSubscr.currency}
                          cardType="subscriptions"
                          // image_url={oneSubscr.image_url}
                          currency={oneSubscr.currency}
                          product={oneSubscr}
                          addToCart={valueFromContext.addToCart}
                          theme={
                            valueFromContext["sections"][blockOrder]["theme"] ||
                            valueFromContext.theme
                          }
                          is_favorite={oneSubscr.is_favorite || 0}
                          in_cart={oneSubscr.in_cart || 0}
                        />
                      </div>
                    );
                  }
                )}
              </СssGroup>
            </CssProductList>
          )}

        {activeModule === "currency" &&
          cardType !== "cart" &&
          !filter &&
          valueFromContext.currency && (
            <CssProductList>
              {/* <CssList0> */}
              {title && (
                <СssTitle
                  theme={
                    valueFromContext["sections"][blockOrder]["theme"] ||
                    valueFromContext.theme
                  }
                >
                  Virtual Currency
                </СssTitle>
              )}
              {/* </CssList0> */}
              <СssGroup
                quantity={valueFromContext.subscriptions["packages"]}
                theme={
                  valueFromContext["sections"][blockOrder]["theme"] ||
                  valueFromContext.theme
                }
                cardType="currency"
                cardWidth={
                  valueFromContext["sections"][blockOrder]["cardWidth"]
                }
              >
                {valueFromContext.currency["list"].map((oneCurr, i) => {
                  return (
                    // <div key={'curr'+i}>
                    <Product
                      template={
                        valueFromContext["sections"][blockOrder]["template"]
                      }
                      // ref={ProductRef}
                      key={i}
                      order={i}
                      initClass="initialFlow1"
                      cardType="currency"
                      sku={i}
                      title={oneCurr.label}
                      description={oneCurr.description}
                      image_url={oneCurr.image}
                      price={oneCurr.sum}
                      priceFull={oneCurr.sumWithoutDiscount || oneCurr.sum}
                      currency={oneCurr.currency}
                    />
                    // </div>
                  );
                })}
              </СssGroup>
            </CssProductList>
          )}
      </div>
    );
  } else {
    return null;
  }
}

export const CssList0 = styled.div`
  position: relative;
  padding: 0 70px;
  width: 100%;
`;

const CssStore00 = styled.div`
  position: relative;
  z-index: 4;
  color: ${({ theme }) => (theme ? theme["colorText"] : "white")};

  padding: 2em 4em 4em 4em;
`;
const CssProductList = styled.div`
  /* position: relative;
  z-index: 4; */
  /* padding-bottom: 4em; */
`;

const CssListBg = styled.div`
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  z-index: 1;
`;

const CssMenu = styled.div`
  /* display: flex; */
  align-items: center;
  flex-grow: 1;
  margin: 24px 0;
`;

const СssTitle = styled.div`
  color: ${({ theme }) => theme["colorText"]};
  padding-top: 2em;
  padding-bottom: 2em;
  min-height: 2em;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
  width: 100%;
  font-size: 1.6em;
  font-weight: bolder;
  /* text-transform: uppercase; */
  letter-spacing: 0.05em;
`;

export default ProductList;

export const OneList = ({ blockOrder = 0, filter, cardType }) => {
  return <div className="" />;
};

const СssGroup = styled.div`



  ${({ cardType, theme }) =>
    cardType !== "cart" &&
    css`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(${({ cardWidth }) =>
      cardWidth ? cardWidth : 200}px, 1fr));
    /* grid-template-columns: repeat(
    ${({ cardWidth }) =>
      cardWidth
        ? parseInt((window.innerWidth - 400) / cardWidth, 0)
        : 4}, minmax(240px, 1fr)); */

    grid-auto-rows: ${({ cardWidth }) =>
      cardWidth
        ? parseInt(cardWidth, 0) + parseInt(cardWidth / 1.2, 0)
        : 240}px;
    grid-column-gap: ${({ cardWidth }) => parseInt(cardWidth / 8, 0)}px;
    grid-row-gap: ${({ cardWidth }) => parseInt(cardWidth / 6, 0)}px;
    /* grid-column-gap: ${({ theme }) => theme["cardPadding"]}px; */
    /* grid-row-gap: ${({ theme }) => theme["cardPadding"]}px; */
    /* grid-template-rows: repeat(auto-fill, minmax(${({ cardWidth }) =>
      cardWidth ? cardWidth : 200}px, 1fr)); */
    /* grid-template-columns: repeat(auto-fill, ${({ cardWidth }) =>
      cardWidth ? cardWidth : 200}px); */


    @media (max-width: 479px) {
      grid-template-columns: repeat(auto-fill, minmax(${({ cardWidth }) =>
        cardWidth ? cardWidth / 2 : 100}px, 1fr));
    };
  `}

  ${({ cardType, theme, quantity }) =>
    (cardType === "subscriptions" || cardType === "currency") &&
    css`
    /* grid-template-columns: repeat(${({ quantity }) => quantity}, 1fr); */
    grid-template-columns: repeat(3, 1fr);
    grid-auto-rows: ${({ cardWidth }) =>
      theme ? parseInt(cardWidth, 0) + parseInt(cardWidth, 0) / 2 : 240}px;
  `};

  ${({ cardType, theme }) =>
    cardType === "cart" &&
    css`
      display: grid;
      grid-template-columns: 1fr;
      grid-row-gap: 16px;
    `};

  /* grid-template-columns: repeat(${({ cardType, quantity }) =>
    cardType === "subscriptions" ? quantity : 1}, 1fr); */


`;
